$(document).ready(function () { 

  if($("#q_ticket_kind_eq").length && $("#q_ticket_kind_eq").val()) {
    handleForm($("#q_ticket_kind_eq").val());
  } else if($("#report_ticket_kind_cd").length && $("#report_ticket_kind_cd").val()) {
    handleForm($("#report_ticket_kind_cd").val());
  }else {
    handleForm($("#report_ticket_kind_cd").val());
  }
});

$(document).on("change", "#q_ticket_kind_eq, #report_ticket_kind_cd, #kind_cd", function () {
  handleForm($(this).val());
});

$(document).on("change", "#q_quotum_administrator_lr_filter", function () {
  var v = $(this).val();
  if (v) {
    $("#q_ticket_kind_eq").val("quotum").trigger("change");
  }
});

function handleForm(value) {
  if(value === "passive_quotum"){
    passiveForm();
  } else if(value === "quotum"){
    quotaForm();
  } else if(value === "currency_term"){
    currencyTermForm();
  } else if(value === "private_fixed_income"){
    privateFixedIncomeForm();
  } else {
    noPassiveForm();
  }
}

function passiveForm() {
  $("#cetip_liquidation_filter").hide().find("input[type='checkbox']").prop("checked", false);
  $("#liquidation_kind, #secondary_market_filter, #invested_fund_name, #shareholder_document_or_name").show();
  $("#propose_number_filter, #asset_code_filter").hide().find("input, select, textarea").val("");

  $("#manager, #fund_name, #fund_name_vi, #fund_document, #fund_document_vi")
    .hide()
    .find("input, select, textarea").val(""); // Limpa os campos escondidos

  refreshVisibleReportSelect2();
  initializePassiveMonitorFundSelect();
}

function quotaForm() {
  $("#cetip_liquidation_filter").hide().find("input[type='checkbox']").prop("checked", false);
  $("#invested_fund_name, #shareholder_document_or_name, #propose_number_filter, #asset_code_filter")
    .hide()
    .find("input, select, textarea").val(""); // Limpa os campos escondidos

  $("#liquidation_kind, #secondary_market_filter, #manager, #fund_name, #fund_name_vi, #fund_document, #fund_document_vi").show();
  refreshVisibleReportSelect2();
}

function privateFixedIncomeForm() {
  $("#propose_number_filter, #asset_code_filter").show();
  $("#cetip_liquidation_filter").hide().find("input[type='checkbox']").prop("checked", false);
  $("#liquidation_kind, #secondary_market_filter, #invested_fund_name, #shareholder_document_or_name")
    .hide()
    .find("input, select, textarea").val("");
  $("#manager, #fund_name, #fund_name_vi, #fund_document, #fund_document_vi").show();
  refreshVisibleReportSelect2();
}

function currencyTermForm() {
  $("#cetip_liquidation_filter").show();
  $("#liquidation_kind, #secondary_market_filter, #invested_fund_name, #shareholder_document_or_name, #propose_number_filter, #asset_code_filter")
    .hide()
    .find("input, select, textarea").val("");

  $("#manager, #fund_name, #fund_name_vi, #fund_document, #fund_document_vi").show();
  refreshVisibleReportSelect2();
}

function noPassiveForm() {
  $("#cetip_liquidation_filter").hide().find("input[type='checkbox']").prop("checked", false);
  $("#liquidation_kind, #secondary_market_filter, #invested_fund_name, #shareholder_document_or_name, #propose_number_filter, #asset_code_filter")
    .hide()
    .find("input, select, textarea").val(""); // Limpa os campos escondidos

  $("#manager, #fund_name, #fund_name_vi, #fund_document, #fund_document_vi").show();
  refreshVisibleReportSelect2();
}

function refreshVisibleReportSelect2() {
  if ($('#form_tickets').length && !$('#form_tickets').is(':visible')) return;
  if ($('#ticket_form').length && !$('#ticket_form').is(':visible')) return;

  if (typeof window.refreshReportSelect2 === 'function') {
    window.refreshReportSelect2();
  }
}

function initializePassiveMonitorFundSelect() {
  if (typeof window.initializePassiveMonitorFundSelects === 'function') {
    window.initializePassiveMonitorFundSelects();
  }
}
